//@flow
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Wrapper, Loader, Button } from 'sputnik-ui'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
} from '@material-ui/core'
import { fetchInvoices, downloadInvoice } from 'store/billing/operations'

const LIMIT = 20

const BillingInvoices = ({ dispatch, invoices, invoicesMeta }) => {
  const [page, setPage] = useState(0)

  useEffect(() => {
    dispatch(fetchInvoices(page, LIMIT))
  }, [dispatch, page])
  const handleDownloadInvoice = (id) => {
    dispatch(downloadInvoice(id))
  }

  if (!invoices) return <Loader />

  return (
    <>
      <TableContainer component={Wrapper}>
        <Table style={{ width: '100%', background: 'white' }}>
          <TableHead>
            <TableRow>
              <TableCell>Номер счета</TableCell>
              <TableCell>Дата</TableCell>
              <TableCell>Сумма</TableCell>
              <TableCell>Статус</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoices.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography color="textSecondary">У вас нет инвойсов</Typography>
                </TableCell>
              </TableRow>
            ) : (
              invoices.map((invoice) => (
                <TableRow key={invoice.operation_id} hover>
                  <TableCell>{invoice.description || invoice.operation_id}</TableCell>
                  <TableCell>
                    {new Date(invoice.date).toLocaleDateString('ru-RU')}
                  </TableCell>
                  <TableCell>{invoice.amount}</TableCell>
                  <TableCell>
                    {invoice.human_status}
                  </TableCell>
                  <TableCell>
                    <>
                      <Button
                        size="small"
                        color="secondary"
                        rounded
                        onClick={() => handleDownloadInvoice(invoice.id) }
                      >
                        Скачать
                      </Button>
                    </>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {invoicesMeta && (
        <TablePagination
          component={Wrapper}
          count={invoicesMeta.total}
          rowsPerPage={LIMIT}
          rowsPerPageOptions={[LIMIT]}
          page={page}
          labelRowsPerPage="Строк на странице:"
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} из ${count}`}
          onChangePage={(_, newPage) => setPage(newPage)}
          style={{ background: 'white' }}
        />
      )}
    </>
  )
}

const mapStateToProps = ({ billing }) => ({
  invoices: billing.invoices,
  invoicesMeta: billing.invoicesMeta,
})

export default connect(mapStateToProps)(BillingInvoices)
